import {
  SET_FETCHER_APPOINTMENT,
  SET_FETCHER_URLS
} from "../actions/action-types";

export const fetcherReducer = (state = {}, action) => {
  if (action.type === SET_FETCHER_URLS) {
    return {
      ...state,
      ...{ urls: action.urls }
    };
  }
  if (action.type === SET_FETCHER_APPOINTMENT) {
    return {
      ...state,
      ...{ appointmentMethod: action.appointmentMethod }
    };
  }

  return state;
};
